module.exports = __webpack_public_path__ + "img/1920px-Roundel_of_France.svg.4cec2a2f.png";